import { ofetch } from 'ofetch';
import { storeToRefs } from 'pinia';

// The giglets frontend code uses $fetch to make API calls.
// Historically the API was hosted on the same domain as the frontend, so it didn't need a base URL.
// The export from this file is auto-imported (using vite.config.mts) so that $fetch now has a base URL.

export const $fetch = ofetch.create({
    async onRequest({ options }) {
        const auth = useAuth();
        const { accessToken } = storeToRefs(auth);

        options.headers.set('Authorization', `Bearer ${accessToken.value}`);
    },
    baseURL: process.env.VITE_API_BASE_URL,
});
